// extracted by mini-css-extract-plugin
export var btnContainer = "ComparisonTable-module--btn-container--50f37";
export var comparison_table_html = "ComparisonTable-module--comparison_table_html--f85e6";
export var consultationCtaBtnV1 = "ComparisonTable-module--consultation-cta-btn-v1--ba269";
export var container = "ComparisonTable-module--container--f3b14";
export var containerBannerV1 = "ComparisonTable-module--container--banner-v1--df29a";
export var containerFooterBottom = "ComparisonTable-module--container--footer-bottom--59eb6";
export var containerFooterTop = "ComparisonTable-module--container--footer-top--96091";
export var containerLargeL = "ComparisonTable-module--container--large-l--8eaa4";
export var containerLargeM = "ComparisonTable-module--container--large-m--849e0";
export var containerMediumL = "ComparisonTable-module--container--medium-l--d601d";
export var containerMediumM = "ComparisonTable-module--container--medium-m--d47dc";
export var containerMob = "ComparisonTable-module--container--mob--5cc00";
export var containerMob1 = "ComparisonTable-module--container--mob-1--4ecac";
export var containerSmallL = "ComparisonTable-module--container--small-l--d4f48";
export var containerSmallM = "ComparisonTable-module--container--small-m--b3dc8";
export var containerSmallS = "ComparisonTable-module--container--small-s--b2d42";
export var containerSmallSub = "ComparisonTable-module--container--small-sub--ca564";
export var containerSmallXl = "ComparisonTable-module--container--small-xl--f30e4";
export var containerV10 = "ComparisonTable-module--container--v10--732f8";
export var containerV12 = "ComparisonTable-module--container--v12--0634b";
export var containerV2 = "ComparisonTable-module--container-v2--73398";
export var containerV3 = "ComparisonTable-module--container-v3--33cda";
export var cursorPointer = "ComparisonTable-module--cursor--pointer--f3636";
export var dkCtaBtn = "ComparisonTable-module--dk-cta-btn--b1a7a";
export var dkCtaBtnArrow = "ComparisonTable-module--dk-cta-btn--arrow--02787";
export var dkCtaBtnBlack = "ComparisonTable-module--dk-cta-btn--black--4b176";
export var dkCtaBtnLarge = "ComparisonTable-module--dk-cta-btn--large--2ce68";
export var dkCtaBtnMid = "ComparisonTable-module--dk-cta-btn--mid--56204";
export var dkCtaBtnSm = "ComparisonTable-module--dk-cta-btn--sm--f6347";
export var dkIcon = "ComparisonTable-module--dkIcon--b36d3";
export var flex = "ComparisonTable-module--flex--ec0e6";
export var flexAcC = "ComparisonTable-module--flex-ac-c--be6fa";
export var flexAiC = "ComparisonTable-module--flex-ai-c--89455";
export var flexDirC = "ComparisonTable-module--flex-dir-c--2e65b";
export var flexJcC = "ComparisonTable-module--flex-jc-c--855f3";
export var flexJcSb = "ComparisonTable-module--flex-jc-sb--f8135";
export var flexShrinkNone = "ComparisonTable-module--flex-shrink-none--830c3";
export var fontPrimary = "ComparisonTable-module--font--primary--2a60a";
export var fontSecondary = "ComparisonTable-module--font--secondary--db59d";
export var gap05x = "ComparisonTable-module--gap-05x--9be21";
export var gap1x = "ComparisonTable-module--gap-1x--abab2";
export var gap1xV2 = "ComparisonTable-module--gap-1x-v2--7f3de";
export var gap2x = "ComparisonTable-module--gap-2x--05e16";
export var gap2xV2 = "ComparisonTable-module--gap-2x-v2--937ba";
export var gap2xV3 = "ComparisonTable-module--gap-2x-v3--9c930";
export var gap3x = "ComparisonTable-module--gap-3x--76cb6";
export var gap3xV2 = "ComparisonTable-module--gap-3x-v2--0f48c";
export var gap3xV3 = "ComparisonTable-module--gap-3x-v3--c58a8";
export var gap3xV4 = "ComparisonTable-module--gap-3x-v4--3b3d6";
export var gap4x = "ComparisonTable-module--gap-4x--5a2ea";
export var gap4xV2 = "ComparisonTable-module--gap-4x-v2--c3119";
export var gap5x = "ComparisonTable-module--gap-5x--65e02";
export var gap5xV2 = "ComparisonTable-module--gap-5x-v2--d688d";
export var gap5xV3 = "ComparisonTable-module--gap-5x-v3--e8a62";
export var gap5xV4 = "ComparisonTable-module--gap-5x-v4--576ef";
export var gap5xV5 = "ComparisonTable-module--gap-5x-v5--720cd";
export var gap6x = "ComparisonTable-module--gap-6x--33558";
export var gap6xV2 = "ComparisonTable-module--gap-6x-v2--90efb";
export var gap6xV3 = "ComparisonTable-module--gap-6x-v3--e615c";
export var gap7x = "ComparisonTable-module--gap-7x--cc603";
export var gap7xV2 = "ComparisonTable-module--gap-7x-v2--cc94b";
export var gap7xV3 = "ComparisonTable-module--gap-7x-v3--87c70";
export var gap7xV4 = "ComparisonTable-module--gap-7x-v4--21ff6";
export var gap8x = "ComparisonTable-module--gap-8x--5922b";
export var gap8xV2 = "ComparisonTable-module--gap-8x-v2--1523b";
export var hideForDesktop = "ComparisonTable-module--hide-for-desktop--78eae";
export var hideForMobile = "ComparisonTable-module--hide-for-mobile--35656";
export var imgW100 = "ComparisonTable-module--img-w-100--cf628";
export var industryCaseStudyBtn = "ComparisonTable-module--industry-case-study-btn--e7ccc";
export var learnMoreBtn = "ComparisonTable-module--learn-more-btn--041f8";
export var learnMoreBtnSmall = "ComparisonTable-module--learn-more-btn--small--70949";
export var loadMoreBtn = "ComparisonTable-module--load-more-btn--1f2a3";
export var mobile_column = "ComparisonTable-module--mobile_column--f6d8c";
export var mobile_column_rightText = "ComparisonTable-module--mobile_column_rightText--a3b8a";
export var mobile_table = "ComparisonTable-module--mobile_table--23e1b";
export var pointerNone = "ComparisonTable-module--pointer-none--67ce6";
export var secondaryBtn = "ComparisonTable-module--secondary-btn--77f4a";
export var table_wrapper = "ComparisonTable-module--table_wrapper--b1f22";
export var tertiaryBtn = "ComparisonTable-module--tertiary-btn--43df2";
export var textBig = "ComparisonTable-module--text-big--f5d5b";
export var textCenter = "ComparisonTable-module--text--center--af6d4";
export var textClrBlue = "ComparisonTable-module--text-clr-blue--63bcb";
export var textClrError = "ComparisonTable-module--text-clr-error--ac4ba";
export var textClrGrey = "ComparisonTable-module--text-clr-grey--22a36";
export var textClrGrey2 = "ComparisonTable-module--text-clr-grey-2--c071f";
export var textClrGrey3 = "ComparisonTable-module--text-clr-grey-3--2c5da";
export var textClrGrey4 = "ComparisonTable-module--text-clr-grey-4--3a0e6";
export var textClrGrey5 = "ComparisonTable-module--text-clr-grey-5--d7294";
export var textClrNeutral400 = "ComparisonTable-module--text-clr-neutral-400--4dad7";
export var textClrOrange = "ComparisonTable-module--text-clr-orange--89acb";
export var textClrPrimary = "ComparisonTable-module--text-clr-primary--93b7a";
export var textClrSecondary = "ComparisonTable-module--text-clr-secondary--e19c5";
export var textClrWhite = "ComparisonTable-module--text-clr-white--b708b";
export var textDecorNone = "ComparisonTable-module--text-decor-none--f47a1";
export var textFwBold = "ComparisonTable-module--text-fw-bold--d8ea2";
export var textFwLight = "ComparisonTable-module--text-fw-light--249f7";
export var textFwMedium = "ComparisonTable-module--text-fw-medium--caaab";
export var textFwRegular = "ComparisonTable-module--text-fw-regular--ab5fa";
export var textFwStrong = "ComparisonTable-module--text-fw-strong--5e8af";
export var textH1 = "ComparisonTable-module--text-h1--546aa";
export var textH2 = "ComparisonTable-module--text-h2--32d79";
export var textH3 = "ComparisonTable-module--text-h3--facdf";
export var textH4 = "ComparisonTable-module--text-h4--fbec0";
export var textH5 = "ComparisonTable-module--text-h5--8cbee";
export var textH6 = "ComparisonTable-module--text-h6--28df3";
export var textLarge = "ComparisonTable-module--text-large--0b991";
export var textLlarge = "ComparisonTable-module--text-llarge--a8399";
export var textP1 = "ComparisonTable-module--text-p1--3fc6d";
export var textP2 = "ComparisonTable-module--text-p2--efb50";
export var textP2V2 = "ComparisonTable-module--text-p2-v2--0e15f";
export var textP3 = "ComparisonTable-module--text-p3--7b683";
export var textP4 = "ComparisonTable-module--text-p4--becbc";
export var textSmall = "ComparisonTable-module--text-small--45dc3";